import React, { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";

export default function BreathMoment() {
  const [phase, setPhase] = useState("in");
  useEffect(() => {
    const id = setInterval(() => setPhase((p) => (p === "in" ? "out" : "in")), 4000);
    return () => clearInterval(id);
  }, []);
  const inhale = phase === "in";

  return (
    <section
      id="breathe"
      data-testid="breath-section"
      className="relative w-full overflow-hidden py-28 md:py-40"
    >
      <div
        className="absolute inset-0"
        style={{ background: "radial-gradient(60% 60% at 50% 50%, rgba(var(--glow),0.16), transparent 70%)" }}
      />
      <div className="relative z-10 max-w-3xl mx-auto px-6 md:px-10 flex flex-col items-center text-center">
        <motion.p
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="font-mono text-[11px] md:text-xs tracking-[0.3em] uppercase text-primary-c mb-5"
          data-testid="breath-eyebrow"
        >
          A Moment to Land
        </motion.p>
        <motion.h2
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8, delay: 0.1 }}
          className="font-serif font-normal text-3xl md:text-5xl leading-[1.05] tracking-tight mb-14"
        >
          Follow the ring. Let your breath find its rhythm.
        </motion.h2>

        <div className="relative h-64 w-64 md:h-80 md:w-80 grid place-items-center" data-testid="breath-guide">
          <motion.span
            className="absolute rounded-full"
            style={{ border: "1px solid var(--primary)", boxShadow: "0 0 90px rgba(139,92,246,0.35)" }}
            animate={{ width: inhale ? 300 : 150, height: inhale ? 300 : 150, opacity: inhale ? 0.9 : 0.4 }}
            transition={{ duration: 3.8, ease: "easeInOut" }}
          />
          <motion.span
            className="absolute rounded-full"
            style={{ border: "1px solid var(--primary)", opacity: 0.25 }}
            animate={{ width: inhale ? 230 : 110, height: inhale ? 230 : 110 }}
            transition={{ duration: 3.8, ease: "easeInOut" }}
          />
          <motion.span
            className="absolute rounded-full"
            style={{ backgroundColor: "var(--primary)", opacity: 0.1 }}
            animate={{ width: inhale ? 170 : 80, height: inhale ? 170 : 80 }}
            transition={{ duration: 3.8, ease: "easeInOut" }}
          />
          <AnimatePresence mode="wait">
            <motion.p
              key={phase}
              initial={{ opacity: 0, scale: 0.96 }}
              animate={{ opacity: 1, scale: 1 }}
              exit={{ opacity: 0, scale: 0.96 }}
              transition={{ duration: 0.6 }}
              className="relative z-10 font-mono text-xs md:text-sm tracking-[0.35em] uppercase text-fg/70"
              data-testid="breath-label"
            >
              {inhale ? "Breathe in" : "Breathe out"}
            </motion.p>
          </AnimatePresence>
        </div>

        <motion.p
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.9, delay: 0.2 }}
          className="mt-14 max-w-md text-sm md:text-base text-fg/60 leading-relaxed"
        >
          No screens to master, no beat to keep. Just a slow, steady pulse to settle
          your nervous system before you go on.
        </motion.p>
      </div>
    </section>
  );
}
